<table [dataSource]="items" mat-table class="condensed">
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell>Produkt</th>
    <td *matCellDef="let interest;" mat-cell>
      {{ interest.product }}
    </td>
  </ng-container>

  @for (b of bindings; track $index) {
    <ng-container [matColumnDef]="b">
      <th *matHeaderCellDef mat-header-cell
          style="padding: 0; white-space: nowrap; text-align: center">
        {{ +b | binding }}
      </th>
      <td *matCellDef="let row;" mat-cell style="padding: 0">
        <!-- see component for an explanation -->
        <spb-interest-input [value]="{p: row.interests[b]}"/>
      </td>
    </ng-container>
  }

  <tr *matHeaderRowDef="columns()" mat-header-row style="font-weight: bold"></tr>
  <tr *matRowDef="let row; columns: columns()" mat-row></tr>
</table>